module.exports = __webpack_public_path__ + "static/img/sxjzIcon.f5a54166.png";